import { Paper } from '@mui/material';
import { styled } from '@mui/system';
import { ComponentPropsWithRef, FC } from 'react';

interface ContainerProps extends ComponentPropsWithRef<'div'> {
    children: React.ReactNode;
}

const Container: FC<ContainerProps> = ({ children, ...props }) => {
    return <StyledContainer {...props}>{children}</StyledContainer>;
};

const StyledContainer = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(5),
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
}));

export default Container;
